const playerAccessTOken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9'

export const PLAYER_PROFILE = {
  data: {
    nickname: 'Wirapong',
    phone: '+6620250421',
    has_bank_account: true,
    currency: 'THB',
    language: 'th-TH',
    bonus_amount: '123829.98',
    country: 'Laos PDR119',
    country_code: 'TH',
    name: 'Jeden Wirapong',
    email: null,
    balance: '12900',
    date_of_birth: '2000-05-07T00:00:00.000Z',
    address: '29-31 Happy Land Soi 2 Latphrao',
    city: 'Bangkapi',
    province: 'Bangkok',
    status: 1,
    platform: 'desktop',
    created_at: '2023-01-19T11:28:22.370Z',
    updated_at: '2025-07-08T03:39:25.954Z',
    player_id: 'johndoe',
    deposit_type: 2,
    is_crypto_payment_enabled: true,
    is_third_party_payment_enabled: true,
    registration_type: 1,
    vip_file: '/demo/tiers/silver.png',
    social_info: [
      {
        id: '0209d45e-ac60-454c-bb4c-4367124072e9',
        social_media_type: 1,
        social_media_id: '@jedenWirapong'
      }
    ],
    is_bank_transfer_enabled: true,
    wl_type: 1
  }
}

export const PLAYER_WALLET = {
  data: { main_wallet: 12900, on_hold_wallet: 0, activity_wallet: 12000 }
}

export const PLAYER_BANK_ACCOUNTS = {
  data: {
    player_bank_accounts: [
      {
        player_bank_name: null,
        android_app_id: 'com.kasikorn.retail.mbanking.wap',
        ios_app_id: 'id361170631',
        bank_id: '2c378374-380c-4b70-8c64-6a021920918a',
        bank_branch: null,
        currency: 'THB',
        id: 'ee81d676-6938-45f3-ba5a-9e8d90318e3e',
        bank_account_number: '1423659380',
        bank_name: {
          'en-US': 'KASIKORNBANK',
          'th-TH': 'ธนาคารกสิกรไทย'
        },
        is_primary: true
      }
    ],
    account_holder_name: 'Warounny Xokvivath'
  }
}

export const PLAYER_CRYPT_WALLETS = {
  data: [
    {
      id: 'd4d7a0bf-b938-49f4-9fb5-4f863d29ecf1',
      wallet_address: 'TPNn7ErZqmmENofe9qpX91PwxSNhYrSfM8',
      currency: 'USDT',
      network: 'TRC20',
      is_primary: true
    }
  ]
}

export const PLAYER_MESSAGES = {
  data: {
    total: 2,
    totalPages: 1,
    data: [
      {
        id: 'de9d33b8-f25d-4d82-9de7-845b641ecd6e',
        subject: {
          'en-US': 'Get Rewarded with Our New Activity System!',
          'th-TH': 'เรียน ท่านลูกค้าผู้ทรงคุณค่า',
          'zh-CN': '尊敬的客户'
        },
        text: {
          'en-US':
            'Dear Valued Customer,\n\nWe are pleased to inform you that we have updated our features with an Activity System. This exciting new feature allows players to participate in various missions and receive coins. These coins can then be exchanged for fantastic rewards, including credits and physical items! We offer four kinds of missions to keep things exciting: Weekly, Monthly, Event, and Action-based. Start playing and earning your rewards today!',
          'th-TH':
            'เรามีความยินดีที่จะแจ้งให้ท่านทราบว่าเราได้อัปเดตฟีเจอร์ใหม่ด้วย ระบบกิจกรรม ที่น่าตื่นเต้น! ฟีเจอร์ใหม่นี้ช่วยให้ผู้เล่นสามารถเข้าร่วมในภารกิจต่างๆ และรับเหรียญได้ เหรียญเหล่านี้สามารถนำไปแลกเปลี่ยนเป็นรางวัลสุดวิเศษ รวมถึง เครดิต และ ไอเท็มจริง! เรามีภารกิจสี่ประเภทเพื่อให้คุณได้เพลิดเพลิน: รายสัปดาห์, รายเดือน, กิจกรรมพิเศษ และ ตามการกระทำ เริ่มเล่นและรับรางวัลของคุณได้แล้ววันนี้!',
          'zh-CN':
            '我们很高兴地通知您，我们已更新了功能，推出了令人兴奋的活动系统！这项新功能允许玩家参与各种任务并获得金币。这些金币可以兑换丰厚奖励，包括信用额度和实物商品！我们提供四种任务类型，让游戏保持刺激：每周任务、每月任务、活动任务和行动任务。立即开始游戏，赢取您的奖励吧！'
        },
        created_at: '2025-07-11T06:57:55.073Z'
      },
      {
        id: '6f1a0fdc-333a-4e6a-9c6e-aea4f7e6616f',
        subject: {
          'en-US': 'Exciting News: Introducing Our New VIP System!',
          'th-TH': 'รับรางวัลกับระบบกิจกรรมใหม่ของเรา!',
          'zh-CN': '参与我们的全新活动系统，赢取奖励！'
        },
        text: {
          'en-US':
            'Dear Valued Customer,\n\nWe are pleased to inform you that we have updated our features with a new VIP System to enhance your experience and allow you to enjoy special treats based on your tier. The higher tier you reach, the more exclusive services and benefits you will receive from us. Get ready for an elevated gaming journey!',
          'th-TH':
            'เรียน ลูกค้าคนสำคัญ,\n\nเรายินดีเป็นอย่างยิ่งที่จะแจ้งให้ทราบว่าเราได้อัปเดตฟีเจอร์ใหม่ด้วย ระบบกิจกรรม (Activity System) ที่น่าตื่นเต้น! ฟีเจอร์ใหม่นี้ช่วยให้ผู้เล่นสามารถเข้าร่วม ภารกิจต่างๆ และ รับเหรียญ ได้ เหรียญเหล่านี้สามารถนำไปแลกเปลี่ยนเป็น รางวัลสุดพิเศษ มากมาย ไม่ว่าจะเป็น เครดิต หรือ ของรางวัลจริง!',
          'zh-CN':
            '尊敬的客户\n\n我们很高兴地通知您，我们已更新功能并推出了全新的活动系统 (Activity System)！这项令人兴奋的新功能允许玩家参与各种任务并获取金币。这些金币可以兑换丰厚奖励，包括积分和实物礼品！\n\n 我们提供四种类型的任务，让您的体验更加精彩：每周任务、每月任务、活动任务和行动任务。立即开始游戏，赢取您的专属奖励吧！'
        },
        created_at: '2025-07-11T06:54:39.652Z'
      }
    ]
  }
}

export const PLAYER_TRANSACTION_HISTORY = {
  data: {
    total: 4,
    total_amount: 370,
    total_bonus: 200,
    totalPages: 1,
    data: [
      {
        id: '46f3ec0b-ccfd-4e1a-a594-c74eeb46c544',
        created_at: '2025-07-11T07:10:32.357Z',
        transaction_type: 'bank_transfer',
        transaction_type_name: 'Bank Transfer',
        amount: '100',
        transfer_type: 1,
        status: 4,
        bonus_amount: '200'
      },
      {
        id: '590d3ea6-cd14-49f9-a4d1-42ef03d3564a',
        created_at: '2025-07-11T06:36:55.194Z',
        transaction_type: 'bank_transfer',
        transaction_type_name: 'Bank Transfer',
        amount: '100',
        transfer_type: 1,
        status: 4,
        bonus_amount: null
      },
      {
        id: '8149d771-1d44-48d9-8496-b8ca76dc5a41',
        created_at: '2025-07-11T05:00:50.178Z',
        transaction_type: 'bank_transfer',
        transaction_type_name: 'Bank Transfer',
        amount: '100',
        transfer_type: 2,
        status: 4,
        bonus_amount: null
      },
      {
        id: '377e872e-ea2a-4f2a-9c0c-474d8e9a0f93',
        created_at: '2025-06-06T06:52:25.488Z',
        transaction_type: 'bank_transfer',
        transaction_type_name: 'Bank Transfer',
        amount: '70',
        transfer_type: 1,
        status: 4,
        bonus_amount: null
      }
    ]
  }
}

export const PLAYER_BET_HISTORIES = {
  data: {
    total: 7,
    totalPages: 1,
    data: [
      {
        id: 'bdac18db-3c0d-4298-9cf0-86fb0413cf33',
        bet_id: '99195bdd-f91b-46ca-ad7b-18a7708da0e8',
        player_id: 'testactmom2',
        player_username: 'wing66testactmom2',
        amount: '2.0000',
        currency: 'THB',
        game_provider_id: 114,
        game_id: 25177,
        game_type: 'SL',
        payout: '0.0000',
        win_loss: '-2.0000',
        commission: '0.0000',
        turnover: '2.0000',
        deduct_time: '2025-06-06T07:15:05.445Z',
        settle_time: '2025-06-06T07:15:05.445Z',
        cancel_time: null,
        status: 2,
        payout_detail: null,
        bet_result: 2,
        jackpot_bet: '0.00',
        jackpot_amount: '0.00',
        created_at: '2025-06-06T07:15:05.642Z',
        updated_at: '2025-06-06T07:15:05.642Z',
        game_id_name: 'dead-man-riches',
        is_free_spin: false,
        is_end_round: true,
        custom_transaction_id: null,
        is_promo: false,
        rollback_time: null,
        action_seq: 1,
        action_status: 1,
        is_admin_canceled: false,
        game_provider_name: 'PG Soft ',
        dddd: 'cfed5dda-625c-498a-b9df-a2d4d80a922e',
        game_type_name: 'Slot',
        game_name: "Dead Man's Riches"
      },
      {
        id: 'a2af22d9-4891-4f5c-b74f-3c245fabd561',
        bet_id: '366e8014-d2e3-48f2-93ce-0ea36183be52',
        player_id: 'testactmom2',
        player_username: 'wing66testactmom2',
        amount: '8.0000',
        currency: 'THB',
        game_provider_id: 114,
        game_id: 25177,
        game_type: 'SL',
        payout: '0.0000',
        win_loss: '-8.0000',
        commission: '0.0000',
        turnover: '8.0000',
        deduct_time: '2025-06-06T07:14:58.276Z',
        settle_time: '2025-06-06T07:14:58.276Z',
        cancel_time: null,
        status: 2,
        payout_detail: null,
        bet_result: 2,
        jackpot_bet: '0.00',
        jackpot_amount: '0.00',
        created_at: '2025-06-06T07:14:58.432Z',
        updated_at: '2025-06-06T07:14:58.432Z',
        game_id_name: 'dead-man-riches',
        is_free_spin: false,
        is_end_round: true,
        custom_transaction_id: null,
        is_promo: false,
        rollback_time: null,
        action_seq: 1,
        action_status: 1,
        is_admin_canceled: false,
        game_provider_name: 'PG Soft ',
        dddd: 'cfed5dda-625c-498a-b9df-a2d4d80a922e',
        game_type_name: 'Slot',
        game_name: "Dead Man's Riches"
      },
      {
        id: 'ee91fcb8-9352-4587-b57c-2e215fa57d2c',
        bet_id: 'a95fac95-ede4-4bda-a9a5-112a7cbbf209',
        player_id: 'testactmom2',
        player_username: 'wing66testactmom2',
        amount: '2.0000',
        currency: 'THB',
        game_provider_id: 114,
        game_id: 25177,
        game_type: 'SL',
        payout: '0.0000',
        win_loss: '-2.0000',
        commission: '0.0000',
        turnover: '2.0000',
        deduct_time: '2025-06-06T07:13:20.222Z',
        settle_time: '2025-06-06T07:13:20.222Z',
        cancel_time: null,
        status: 2,
        payout_detail: null,
        bet_result: 2,
        jackpot_bet: '0.00',
        jackpot_amount: '0.00',
        created_at: '2025-06-06T07:13:20.361Z',
        updated_at: '2025-06-06T07:13:20.361Z',
        game_id_name: 'dead-man-riches',
        is_free_spin: false,
        is_end_round: true,
        custom_transaction_id: null,
        is_promo: false,
        rollback_time: null,
        action_seq: 1,
        action_status: 1,
        is_admin_canceled: false,
        game_provider_name: 'PG Soft ',
        dddd: 'cfed5dda-625c-498a-b9df-a2d4d80a922e',
        game_type_name: 'Slot',
        game_name: "Dead Man's Riches"
      },
      {
        id: '0ed59efb-b0a6-45a2-a9db-53576f60ea06',
        bet_id: '1e603d66-21e4-421d-b8a0-842e55e00367',
        player_id: 'testactmom2',
        player_username: 'wing66testactmom2',
        amount: '20.0000',
        currency: 'THB',
        game_provider_id: 114,
        game_id: 25177,
        game_type: 'SL',
        payout: '2.0000',
        win_loss: '-18.0000',
        commission: '0.0000',
        turnover: '18.0000',
        deduct_time: '2025-06-06T07:13:04.191Z',
        settle_time: '2025-06-06T07:13:04.191Z',
        cancel_time: null,
        status: 2,
        payout_detail: null,
        bet_result: 2,
        jackpot_bet: '0.00',
        jackpot_amount: '0.00',
        created_at: '2025-06-06T07:13:04.380Z',
        updated_at: '2025-06-06T07:13:04.380Z',
        game_id_name: 'dead-man-riches',
        is_free_spin: false,
        is_end_round: true,
        custom_transaction_id: null,
        is_promo: false,
        rollback_time: null,
        action_seq: 1,
        action_status: 1,
        is_admin_canceled: false,
        game_provider_name: 'PG Soft ',
        dddd: 'cfed5dda-625c-498a-b9df-a2d4d80a922e',
        game_type_name: 'Slot',
        game_name: "Dead Man's Riches"
      },
      {
        id: 'b0c954e5-bfc0-4871-9cdb-9f1187e4f98e',
        bet_id: '6a025c99-040a-45ad-9196-829f372ab0f7',
        player_id: 'testactmom2',
        player_username: 'wing66testactmom2',
        amount: '300.0000',
        currency: 'THB',
        game_provider_id: 114,
        game_id: 25177,
        game_type: 'SL',
        payout: '0.0000',
        win_loss: '-300.0000',
        commission: '0.0000',
        turnover: '300.0000',
        deduct_time: '2025-06-06T07:12:48.912Z',
        settle_time: '2025-06-06T07:12:48.912Z',
        cancel_time: null,
        status: 2,
        payout_detail: null,
        bet_result: 2,
        jackpot_bet: '0.00',
        jackpot_amount: '0.00',
        created_at: '2025-06-06T07:12:49.074Z',
        updated_at: '2025-06-06T07:12:49.074Z',
        game_id_name: 'dead-man-riches',
        is_free_spin: false,
        is_end_round: true,
        custom_transaction_id: null,
        is_promo: false,
        rollback_time: null,
        action_seq: 1,
        action_status: 1,
        is_admin_canceled: false,
        game_provider_name: 'PG Soft ',
        dddd: 'cfed5dda-625c-498a-b9df-a2d4d80a922e',
        game_type_name: 'Slot',
        game_name: "Dead Man's Riches"
      },
      {
        id: '23565628-1614-4e04-a211-73af6d8d14c7',
        bet_id: 'f78fc834-4eac-44d2-ac10-0b9246e49ef9',
        player_id: 'testactmom2',
        player_username: 'wing66testactmom2',
        amount: '90.0000',
        currency: 'THB',
        game_provider_id: 114,
        game_id: 25177,
        game_type: 'SL',
        payout: '0.0000',
        win_loss: '-90.0000',
        commission: '0.0000',
        turnover: '90.0000',
        deduct_time: '2025-06-06T07:04:59.395Z',
        settle_time: '2025-06-06T07:04:59.395Z',
        cancel_time: null,
        status: 2,
        payout_detail: null,
        bet_result: 2,
        jackpot_bet: '0.00',
        jackpot_amount: '0.00',
        created_at: '2025-06-06T07:04:59.595Z',
        updated_at: '2025-06-06T07:04:59.595Z',
        game_id_name: 'dead-man-riches',
        is_free_spin: false,
        is_end_round: true,
        custom_transaction_id: null,
        is_promo: false,
        rollback_time: null,
        action_seq: 1,
        action_status: 1,
        is_admin_canceled: false,
        game_provider_name: 'PG Soft ',
        dddd: 'cfed5dda-625c-498a-b9df-a2d4d80a922e',
        game_type_name: 'Slot',
        game_name: "Dead Man's Riches"
      },
      {
        id: 'c0078603-fdd4-4bc5-b330-dfa514244a00',
        bet_id: '0f040b86-e1a2-4d77-a00c-7cd8ca4b11b1',
        player_id: 'testactmom2',
        player_username: 'wing66testactmom2',
        amount: '30.0000',
        currency: 'THB',
        game_provider_id: 114,
        game_id: 25177,
        game_type: 'SL',
        payout: '0.0000',
        win_loss: '-30.0000',
        commission: '0.0000',
        turnover: '30.0000',
        deduct_time: '2025-06-06T06:53:28.567Z',
        settle_time: '2025-06-06T06:53:28.567Z',
        cancel_time: null,
        status: 2,
        payout_detail: null,
        bet_result: 2,
        jackpot_bet: '0.00',
        jackpot_amount: '0.00',
        created_at: '2025-06-06T06:53:28.736Z',
        updated_at: '2025-06-06T06:53:28.736Z',
        game_id_name: 'dead-man-riches',
        is_free_spin: false,
        is_end_round: true,
        custom_transaction_id: null,
        is_promo: false,
        rollback_time: null,
        action_seq: 1,
        action_status: 1,
        is_admin_canceled: false,
        game_provider_name: 'PG Soft ',
        dddd: 'cfed5dda-625c-498a-b9df-a2d4d80a922e',
        game_type_name: 'Slot',
        game_name: "Dead Man's Riches"
      }
    ],
    total_overall_bet_count: '7',
    total_overall_bet_amount: '452.0000',
    total_overall_turnover_amount: '450.0000',
    total_overall_win_loss_amount: '-450.0000'
  }
}

export const GAME_TYPES = {
  data: [
    {
      id: '4e9828fd-8e8f-4385-97c1-fade4a7348cd',
      code: 'SL',
      name: 'Slot',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:12.412Z',
      updated_at: '2022-12-14T09:02:12.412Z'
    },
    {
      id: 'a7e2ff59-bfa2-4c15-8479-9a951945be16',
      code: 'LC',
      name: 'Live Casino',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:12.610Z',
      updated_at: '2022-12-14T09:02:12.610Z'
    },
    {
      id: '841ef921-6ec6-4bd6-9991-e4664174ca20',
      code: 'FH',
      name: 'Fishing',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:12.734Z',
      updated_at: '2022-12-14T09:02:12.734Z'
    },
    {
      id: 'c49863d5-fd75-4724-9d64-eddd85589a26',
      code: 'LT',
      name: 'Lottery',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:13.190Z',
      updated_at: '2022-12-14T09:02:13.190Z'
    },
    {
      id: 'c6c46eaa-e41a-4b3c-89a7-dd5b875a770b',
      code: 'OT',
      name: 'Other',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:14.614Z',
      updated_at: '2022-12-14T09:02:14.614Z'
    },
    {
      id: '850d6b2f-0117-4cd6-b73d-9de013d6bb3f',
      code: 'VS',
      name: 'Virtual Sports',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:13.671Z',
      updated_at: '2022-12-14T09:02:13.671Z'
    },
    {
      id: '5c0935f3-f394-42cd-9f0f-901fe3f9f992',
      code: 'SP',
      name: 'Sports',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:13.294Z',
      updated_at: '2022-12-14T09:02:13.294Z'
    },
    {
      id: '1eb5c8e3-9eb9-4b94-9ee1-2274b298bcd4',
      code: 'TB',
      name: 'Table',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:13.100Z',
      updated_at: '2022-12-14T09:02:13.100Z'
    },
    {
      id: 'b226be77-d520-4617-8501-0eb8131cd9a7',
      code: 'AN',
      name: 'Animal',
      status: 'active',
      is_visible: true,
      created_at: '2022-12-14T09:02:14.138Z',
      updated_at: '2022-12-14T09:02:14.138Z'
    }
  ]
}

export const PLAYER_INVITE_AND_EARN = {
  data: {
    total: 5,
    total_commission: 1200,
    total_pages: 1,
    total_number_of_friend: '5',
    number_of_friend: 1,
    available_commission: 0,
    is_claimable: false,
    data: [
      {
        claim_time: null,
        number_of_friend: '1',
        min_percentage: '100',
        max_percentage: '100',
        commission: '350.00',
        status: 1
      },
      {
        claim_time: '2025-06-07T07:37:40.805Z',
        number_of_friend: '1',
        min_percentage: '100',
        max_percentage: '100',
        commission: '350.00',
        status: 2
      },
      {
        claim_time: '2025-06-07T07:09:11.263Z',
        number_of_friend: '1',
        min_percentage: '100',
        max_percentage: '100',
        commission: '100.00',
        status: 2
      },
      {
        claim_time: '2025-06-07T06:45:30.402Z',
        number_of_friend: '1',
        min_percentage: '100',
        max_percentage: '100',
        commission: '50.00',
        status: 2
      },
      {
        claim_time: '2025-06-06T17:05:20.211Z',
        number_of_friend: '1',
        min_percentage: '100',
        max_percentage: '100',
        commission: '350.00',
        status: 2
      }
    ]
  }
}

export const PLAYER_PROMOTION_HISTORY = {
  data: {
    total: 11,
    totalPages: 2,
    total_bonus_amount: 2970,
    data: [
      {
        id: '0062a332-a32d-4214-90ee-85a754c8fdfb',
        bonus_type: 2,
        promotion_name: null,
        name: null,
        bonus_amount: '100',
        status: 3,
        code: 'ijpoiilj',
        start_time: '2025-07-11T07:12:49.574Z',
        expire_time: null
      },
      {
        id: '9d22f94a-9ced-4a6e-b3f4-c1ff330519eb',
        bonus_type: 1,
        promotion_name: {
          'en-US': 'TEST acti',
          'th-TH': 'TEST acti',
          'zh-CN': 'TEST acti'
        },
        name: null,
        bonus_amount: '200',
        status: 2,
        code: null,
        start_time: '2025-07-11T07:11:13.257Z',
        expire_time: '2025-07-11T07:11:41.000Z'
      },
      {
        id: '31b4deb9-b45a-4f70-8af7-636782d5b11b',
        bonus_type: 3,
        promotion_name: null,
        name: null,
        bonus_amount: '450',
        status: 1,
        code: null,
        start_time: null,
        expire_time: null
      },
      {
        id: '428cf3d5-e82c-4b66-91f6-119065383af4',
        bonus_type: 4,
        promotion_name: null,
        name: null,
        bonus_amount: '350',
        status: 1,
        code: null,
        start_time: null,
        expire_time: null
      },
      {
        id: '5ed12546-a402-4fa6-9859-1f59976d500e',
        bonus_type: 3,
        promotion_name: null,
        name: null,
        bonus_amount: '450',
        status: 2,
        code: null,
        start_time: '2025-06-07T07:37:43.180Z',
        expire_time: '2025-07-11T05:00:38.000Z'
      },
      {
        id: 'aa5245c5-4ef8-4408-839c-97766a8af9b2',
        bonus_type: 4,
        promotion_name: null,
        name: null,
        bonus_amount: '350',
        status: 2,
        code: null,
        start_time: '2025-06-07T07:37:40.805Z',
        expire_time: '2025-07-11T05:00:38.000Z'
      },
      {
        id: 'bcee5027-b2b4-4c9e-924b-9ea836cbbad5',
        bonus_type: 4,
        promotion_name: null,
        name: null,
        bonus_amount: '100',
        status: 2,
        code: null,
        start_time: '2025-06-07T07:09:11.263Z',
        expire_time: '2025-06-06T07:14:12.910Z'
      },
      {
        id: 'eeb88599-644b-4583-b96f-77854c05db8c',
        bonus_type: 3,
        promotion_name: null,
        name: null,
        bonus_amount: '120',
        status: 2,
        code: null,
        start_time: '2025-06-07T07:09:08.989Z',
        expire_time: '2025-06-06T07:14:12.852Z'
      },
      {
        id: '50f667fa-c6d3-4d89-9524-ee14a229b8f1',
        bonus_type: 4,
        promotion_name: null,
        name: null,
        bonus_amount: '50',
        status: 2,
        code: null,
        start_time: '2025-06-07T06:45:30.402Z',
        expire_time: '2025-06-06T06:53:03.000Z'
      },
      {
        id: '7d7b5f71-fdb1-45ac-8507-1a0703feead5',
        bonus_type: 3,
        promotion_name: null,
        name: null,
        bonus_amount: '450',
        status: 2,
        code: null,
        start_time: '2025-06-06T17:05:44.510Z',
        expire_time: '2025-07-11T05:00:38.000Z'
      }
    ]
  }
}

export const PLAYER_DEPOSIT_IS_EXIST = {
  data: { is_exist: false }
}

export const PROMOTION_END = {
  data: [
    {
      total_turnover: '1',
      turnover_left: '1',
      bonus_claim_at: '2024-09-05T10:05:22.942Z',
      id: '460ad5ba-10b7-414c-80b0-6fa547a4abbd',
      name: '投注彩金',
      currency: 'THB',
      promotion_type: 1,
      promotion_type_conditions: null,
      promotion_claim_type: 5,
      player_type: 1,
      time_zone: 'Asia/Bangkok',
      promotion_start: '2024-07-28T17:00:00.000Z',
      promotion_end: '2024-12-31T16:59:59.000Z',
      display_name: {
        'en-US': 'New Promotion: Guess the Score',
        'th-TH': 'โปรโมชั่นใหม่ ทายผลบอลถูก รับโบนัสสูงสุด',
        'zh-CN': '新活动：猜中比分 赢取最高 50 奖金'
      },
      thumbnail_image: {
        'zh-CN': '/demo/promotions/image-3-ch.png',
        'th-TH': '/demo/promotions/image-3-th.png',
        'en-US': '/demo/promotions/image-3-en.png'
      },
      promotion_image: {
        'zh-CN': '/demo/promotions/image-3-ch.png',
        'th-TH': '/demo/promotions/image-3-th.png',
        'en-US': '/demo/promotions/image-3-en.png'
      },
      description: {
        'en-US':
          "<h2><strong>🥊 Special Promo: Guess the Boxing Winner &amp; Get 100% Bonus up to 50000 🔥</strong></h2><p><br></p><p>📌 <strong>How to Join:</strong></p><p> ✅ Predict the winning boxer or win by knockout</p><p> ✅ If correct, receive 100% bonus based on your current deposit (up to 50000)</p><p> ✅ Bonus is calculated from your latest deposit</p><p> ✅ 2x turnover required from (deposit + bonus) before withdrawal</p><p> ✅ Open to all players, and you can participate multiple times</p><p> ✅ Available daily or based on boxing match events</p><p> ✅ Bonus can only be used for boxing game bets</p><p><br></p><p>📌 <strong>Additional Terms:</strong></p><ul><li>One user can claim multiple times based on new match events</li><li>Fraudulent behavior will result in forfeiture of bonus and withdrawal rights</li><li>Subject to the platform's general Terms &amp; Conditions</li></ul><p><br></p>",
        'th-TH':
          '<h2><strong>🥊 โปรโมชั่นพิเศษ ทายมวยถูก รับโบนัส 100% สูงสุด 50000 🔥</strong></h2><p><br></p><p>📌 <strong>วิธีเข้าร่วมโปรโมชั่น:</strong></p><p> ✅ ทายผลนักมวยที่จะชนะ หรือ ชนะด้วยการน็อกเอาท์</p><p> ✅ หากทายถูก รับโบนัส 100% ของยอดฝากปัจจุบัน สูงสุดไม่เกิน 50000</p><p> ✅ โบนัสคำนวณจากยอดฝากล่าสุด</p><p> ✅ ต้องทำเทิร์นโอเวอร์ 2 เท่าของยอดฝาก + โบนัส ก่อนถอน</p><p> ✅ ผู้เล่นทุกคนสามารถเข้าร่วมได้ และสามารถร่วมกิจกรรมได้หลายครั้ง</p><p> ✅ โปรโมชั่นนี้เปิดให้ร่วมได้ทุกวัน หรือ ตามรอบการแข่งขัน</p><p> ✅ โบนัสใช้ได้เฉพาะกับการเดิมพันหมวดมวยเท่านั้น</p><p><br></p><p>📌 <strong>เงื่อนไขเพิ่มเติม:</strong></p><ul><li>1 ยูสเซอร์สามารถรับได้หลายครั้ง ตราบใดที่ร่วมในรอบใหม่ของการแข่งขัน</li><li>หากตรวจพบการทุจริต ทางเราขอสงวนสิทธิ์ในการระงับการถอนเงิน</li><li>โปรโมชั่นเป็นไปตามข้อกำหนดและเงื่อนไขของเว็บไซต์</li></ul><p><br></p>',
        'zh-CN':
          '<h2><strong>🥊 特别活动：猜中拳击胜者 赢取 100% 奖金 最高 50000 🔥</strong></h2><p><br></p><p>📌 <strong>参与方式：</strong></p><p> ✅ 猜中获胜拳手或是否以击倒方式取胜</p><p> ✅ 猜中即可获得当前充值金额的 100% 奖金，最高不超过 50000</p><p> ✅ 奖金将根据最新充值金额计算</p><p> ✅ 提现前需完成（充值 + 奖金）总额的 2 倍流水</p><p> ✅ 所有玩家皆可参加，每位玩家可参与多次</p><p> ✅ 活动每日开放，或根据比赛场次进行</p><p> ✅ 奖金仅限用于拳击类游戏下注</p><p><br></p><p>📌 <strong>补充条款：</strong></p><ul><li>每位用户可多次参与不同场次</li><li>如发现作弊行为，平台将取消奖金与提款资格</li><li>所有活动遵循平台通用条款与规定</li></ul><p><br></p>'
      },
      claim_condition_type: 1,
      claim_condition: [
        {
          condition: 9,
          value: '50',
          value_type: 2,
          variable: 4
        }
      ],
      player_reward_condition: {
        condition: 2,
        variable: 2,
        value_type: 1,
        value: '10',
        max_bonus: '10000'
      },
      to_complete_bonus_condition: [
        {
          condition: 1,
          value: '1',
          value_type: 2,
          variable: 4
        }
      ],
      withdrawal_condition_type: 2,
      withdrawal_condition: [
        {
          condition: 1,
          value: '10',
          value_type: 2,
          variable: 2,
          withdrawal_type: 2,
          withdrawal_value: '20'
        }
      ],
      to_complete_bonus_condition_type: 1,
      sequence: null,
      is_display_only: false,
      is_visible: true,
      is_active: true,
      is_deleted: true,
      created_at: '2024-07-29T16:00:02.986Z',
      updated_at: '2025-01-16T06:29:51.799Z'
    },
    {
      total_turnover: '200',
      turnover_left: '0',
      bonus_claim_at: '2023-05-10T09:18:52.049Z',
      id: '2f4b654d-f44b-481f-93b7-f2fee348a18f',
      name: 'โปรโมชั่นเกมสล็อต',
      currency: 'THB',
      promotion_type: 1,
      promotion_type_conditions: null,
      promotion_claim_type: 2,
      player_type: 1,
      time_zone: 'Asia/Bangkok',
      promotion_start: '2023-05-12T17:00:00.000Z',
      promotion_end: '2023-06-25T16:23:59.000Z',
      display_name: {
        'en-US': 'Slot Loss Rebate Promotion',
        'th-TH': 'โปรโมชั่นคืนยอดเสียสล็อต',
        'zh-CN': '老虎机亏损回馈活动'
      },
      thumbnail_image: {
        'zh-CN': '/demo/promotions/image-4-ch.png',
        'th-TH': '/demo/promotions/image-4-th.png',
        'en-US': '/demo/promotions/image-4-en.png'
      },
      promotion_image: {
        'zh-CN': '/demo/promotions/image-4-ch.png',
        'th-TH': '/demo/promotions/image-4-th.png',
        'en-US': '/demo/promotions/image-4-en.png'
      },
      description: {
        'en-US':
          '<h2><strong>🎰 Slot Loss Rebate Promotion – Get Up to 10% Daily! 🔥</strong></h2><p><br></p><p>📌 <strong>Promotion Details:</strong></p><p>✅ Get up to <strong>10% rebate</strong>, capped at <strong>10000</strong></p><p> ✅ Applies <strong>only to losses from slot games</strong></p><p> ✅ Daily rebate tiers based on net loss:</p><ul><li>Loss between <strong>-10000000 to -5000000</strong> → <strong>10% rebate</strong></li><li>Loss between <strong>-5000000 to -1000000</strong> → <strong>5% rebate</strong></li><li>Loss between <strong>-1000000 to -1</strong> → <strong>3% rebate</strong></li></ul><p><strong><span class="ql-cursor">﻿</span></strong></p><p>📌 <strong>Terms and Conditions:</strong></p><p>1). Applies to <strong>slot game losses only</strong></p><p> 2). <strong>Only real money losses</strong> are eligible — losses from bonus money are excluded</p><p> 3). All players are eligible to receive this <strong>daily</strong>, based on qualifying losses</p><p> 4). Rebate will be credited automatically or as scheduled</p><p> 5). Subject to the platform’s Terms &amp; Conditions</p><p><br></p>',
        'th-TH':
          '<h2><strong>🎰 โปรโมชั่นคืนยอดเสียสล็อต สูงสุด 10% รับคืนได้ทุกวัน 🔥</strong></h2><p><br></p><p>📌 <strong>รายละเอียดโปรโมชั่น:</strong></p><p>✅ คืนยอดเสียสูงสุด 10% สูงสุดไม่เกิน 10000</p><p> ✅ คำนวณเฉพาะยอดเสียจากเกมประเภทสล็อตเท่านั้น</p><p> ✅ คืนยอดเสียตามระดับยอดเสียรายวัน:</p><ul><li>ยอดเสียระหว่าง <strong>-10000000 ถึง -5000000</strong> → รับคืน <strong>10%</strong></li><li>ยอดเสียระหว่าง <strong>-5000000 ถึง -1000000</strong> → รับคืน <strong>5%</strong></li><li>ยอดเสียระหว่าง <strong>-1000000 ถึง -1</strong> → รับคืน <strong>3%</strong></li></ul><p><strong><span class="ql-cursor">﻿</span></strong></p><p>📌 <strong>เงื่อนไขโปรโมชั่น:</strong></p><p>1). เฉพาะยอดเสียจากเกมสล็อตเท่านั้น</p><p> 2). คำนวณเฉพาะยอดเสียจาก <strong>เงินจริงเท่านั้น</strong> — ยอดเสียจากโบนัสจะไม่ถูกรวม</p><p> 3). ผู้เล่นทุกคนสามารถรับโปรโมชั่นนี้ได้ <strong>ทุกวัน</strong> หากมียอดเสียตามเกณฑ์</p><p> 4). คืนยอดเสียเข้าสู่กระเป๋าหลักโดยอัตโนมัติ หรือ ตามเวลาที่กำหนด</p><p> 5). เป็นไปตามข้อกำหนดและเงื่อนไขของเว็บไซต์</p>',
        'zh-CN':
          '<h2><strong>🎰 老虎机亏损回馈活动 – 每日返还最高 10% 🔥</strong></h2><p><br></p><p>📌 <strong>活动详情：</strong></p><p>✅ 每日返还亏损金额 <strong>最高 10%</strong>，上限为 <strong>10000</strong></p><p> ✅ 仅适用于 <strong>老虎机游戏的亏损金额</strong></p><p> ✅ 亏损等级返还如下：</p><ul><li><strong>亏损 -10000000 至 -5000000</strong> → 返还 <strong>10%</strong></li><li><strong>亏损 -5000000 至 -1000000</strong> → 返还 <strong>5%</strong></li><li><strong>亏损 -1000000 至 -1</strong> → 返还 <strong>3%</strong></li></ul><p><strong><span class="ql-cursor">﻿</span></strong></p><p>📌 <strong>活动规则：</strong></p><p>1). 仅计算来自 <strong>老虎机游戏的亏损</strong></p><p> 2). 仅计算 <strong>真钱亏损</strong>，<strong>不包含奖金亏损部分</strong></p><p> 3). 所有玩家每日可享受此优惠，只要达到亏损门槛</p><p> 4). 回馈金额将自动发放或按时间发放</p><p> 5). 所有活动需遵守平台的条款与规定</p>'
      },
      claim_condition_type: 1,
      claim_condition: [
        {
          condition: 2,
          value: '10',
          value_type: 2,
          variable: 4
        }
      ],
      player_reward_condition: {
        condition: 2,
        variable: 2,
        value_type: 1,
        value: '70',
        max_bonus: '2100'
      },
      to_complete_bonus_condition: [
        {
          condition: 1,
          value: '5',
          value_type: 1,
          variable: 4
        }
      ],
      withdrawal_condition_type: 2,
      withdrawal_condition: [
        {
          condition: 1,
          value: '5',
          value_type: 2,
          variable: 4,
          withdrawal_type: 2,
          withdrawal_value: '1500'
        }
      ],
      to_complete_bonus_condition_type: 1,
      sequence: null,
      is_display_only: false,
      is_visible: true,
      is_active: true,
      is_deleted: true,
      created_at: '2023-03-31T10:13:40.949Z',
      updated_at: '2023-12-15T04:30:52.778Z'
    }
  ]
}

export const COIN_HISTORY = {
  data: {
    total: 2,
    totalPages: 1,
    total_amount: 101,
    data: [
      {
        _id: '687099246ee2a8920fcc7917',
        mission_type: 3,
        activity_name: {
          'en-US': '1',
          'th-TH': '1',
          'zh-CN': '1'
        },
        claim_time: '2025-07-11T06:37:10.255Z',
        amount: 1
      },
      {
        _id: '6842706cea76857382786caf',
        mission_type: 4,
        activity_name: {
          'en-US': 'Login',
          'th-TH': 'Login',
          'zh-CN': 'Login'
        },
        claim_time: '2025-06-06T04:47:15.535Z',
        amount: 100
      }
    ]
  }
}

export const PLAYER_UPDATE_SUCCESS = {
  data: { error: false, code: 12011, message: "Players's profile updated" }
}

export const LOGIN_RESPONSE = {
  status: 200,
  headers: {
    token: playerAccessTOken
  },
  data: {
    last_login_ip: '139.15.157.111',
    nickname: 'Wirapong Wirapong',
    phone: '+6620250421',
    has_bank_account: true,
    is_phone_verified: false,
    currency: 'USDT',
    language: '',
    favorite_games: null,
    reg_ip: '103.137.90.108',
    reg_fingerprint: 'b329cd3e721addd1459a6b840b5d1fcb',
    bonus_amount: '123829.98',
    country: 'Laos PDR119',
    country_code: 'TH',
    name: 'Wirapong Wirapong',
    email: 'wirapong@gmail.com',
    banner_id: null,
    is_reg_banner: false,
    online_status: 1,
    total_deposit: '3029436.82',
    total_deposit_count: 98,
    total_withdrawal: '6116',
    total_withdrawal_count: 33,
    last_login_time: '2025-07-08T07:14:56.000Z',
    login_count: 1252,
    login_error_count: 157,
    last_deposit_time: '2025-05-22T10:01:17.592Z',
    last_withdraw_time: '2024-11-27T12:53:46.140Z',
    first_deposit_time: '2023-04-26T08:28:50.559Z',
    first_withdraw_time: '2023-04-26T08:35:41.377Z',
    deposit_avg: '30912.62',
    is_promo: false,
    total_turnover_amount: '7836404.55',
    total_win_loss_amount: '-5365238.80',
    withdraw_avg: '185.33',
    balance: '4194514.11',
    date_of_birth: '2025-05-07T00:00:00.000Z',
    address: '29-31 Happy Land Soi 2 Latphrao',
    city: 'Land Soi 2',
    province: 'Latphrao',
    zalo_number: null,
    turnover_left: '1014445511.21',
    status: 1,
    platform: 'desktop',
    is_internal_player: false,
    created_at: '2023-01-19T11:28:22.370Z',
    updated_at: '2025-07-08T07:14:54.172Z',
    player_id: 'johndoe',
    sbo_username: null,
    parent_id: null,
    agent_uuid: null,
    ref_type: null,
    player_ref_rel_code: 'ft',
    player_ref_status: true,
    affiliate_uuid: null,
    deposit_type: 1,
    is_crypto_payment_enabled: false,
    is_third_party_payment_enabled: false,
    registration_type: 1,
    wl_type: 1
  }
}

export const RESET_PASSWORD_RESPONSE = {
  data: { error: false, code: 12008, message: 'Reset password success' }
}

export const PLAYER_REGISTRATION_RESPONSE = {
  data: {
    is_phone_verified: false,
    reg_fingerprint: null,
    bonus_amount: '0',
    email: null,
    online_status: true,
    total_deposit: '0',
    total_deposit_count: 0,
    total_withdrawal: '0',
    total_withdrawal_count: 0,
    login_error_count: 0,
    deposit_avg: '0',
    is_promo: false,
    total_turnover_amount: '0',
    total_win_loss_amount: '0',
    withdraw_avg: '0',
    address: null,
    city: null,
    province: null,
    zalo_number: null,
    turnover_left: '0',
    status: 1,
    is_internal_player: false,
    favorite_games: null,
    player_ref_status: false,
    total_bet_amount: '0',
    promotion_bonus_amount: '0',
    promotion_bonus_count: 0,
    promocode_bonus_amount: '0',
    promocode_bonus_count: 0,
    rolling_bonus_amount: '0',
    rolling_bonus_count: 0,
    refer_friend_bonus_amount: '0',
    refer_friend_bonus_count: 0,
    total_manual_adjustment: '0',
    total_manual_adjustment_count: 0,
    gender: null,
    first_deposit_amount: '0',
    first_withdraw_amount: '0',
    last_deposit_amount: '0',
    last_withdraw_amount: '0',
    manual_adj_sub_amount: '0',
    manual_adj_add_count: 0,
    manual_adj_sub_count: 0,
    manual_adj_add_amount: '0',
    referrer_reward_status: true,
    banner_status: 1,
    last_turnover_update_time: '2025-07-09T10:25:06.748Z',
    origin_url: null,
    total_reward_credit_amount: '0',
    total_reward_credit_quantity: 0,
    total_reward_item_quantity: 0,
    total_vip_level_up_amount: '0',
    total_vip_birthday_amount: '0',
    total_reward_credit_count: '0',
    total_vip_level_up_count: '0',
    total_vip_birthday_count: '0',
    vip_tier_condition_type: 0,
    vip_tier_min_range: '0',
    vip_tier_max_range: '0',
    total_claimed_coin: '0',
    total_used_coin: '0',
    total_claimed_coin_count: '0',
    total_used_coin_count: '0',
    is_social_media_added: false,
    has_crypto_wallet: false,
    platform: 'desktop',
    country: 'Thailand',
    reg_ip: '115.84.114.67',
    last_login_time: '2025-07-09T10:25:07.055Z',
    login_count: 1,
    is_reg_banner: false,
    sbo_username: 'test8919',
    has_bank_account: true,
    phone: '+6620392910',
    currency: 'THB',
    language: 'en-US',
    country_code: 'TH',
    player_id: 'test8919',
    name: 'Helo world yong seng',
    first_name: 'world',
    last_name: 'yong',
    deposit_type: 2,
    is_crypto_payment_enabled: true,
    is_third_party_payment_enabled: true,
    registration_type: 1,
    login_info: {
      fingerprint: 'd9e68f79d3444524dcac2fd6c685180d2030ad1d8ae521b241486f1e24a233ef',
      browser: 'Chrome',
      ip: '115.84.114.67',
      country: 'Laos',
      city: 'Vientiane',
      os: 'Mac OS 10.15.7',
      device_type: 'desktop'
    },
    updated_at: '2025-07-09T10:25:07.644Z',
    created_at: '2025-07-09T10:25:07.644Z',
    banner_id: null,
    last_deposit_time: null,
    last_withdraw_time: null,
    first_deposit_time: null,
    first_withdraw_time: null,
    date_of_birth: null,
    vip_level_id: null,
    reg_by_user_id: null,
    agent_username: null,
    group: null,
    self_server_id: null,
    sbo_server_id: null,
    parent_id: null,
    agent_uuid: null,
    player_ref_rel_code: null,
    affiliate_uuid: null,
    ref_type: null,
    gi_username: null,
    last_login_ip: null,
    note: null,
    nickname: null,
    native_name: null,
    vip_tier_id: null,
    vip_tier_signature: null
  },
  headers: {
    token: playerAccessTOken
  }
}

export const PLAYER_NOTIFICATIONS = {
  data: [
    {
      _id: '6870b97c6ee2a8920fcc7b40',
      vip_tier_id: null,
      mission_id: 'ec7877c8-3793-4d28-bc41-bf67ef741fa5',
      mission_type: 1,
      activity_id: 'ab7312dc-38f7-401c-9441-c44f67b0bcdc',
      expiration: '2025-07-18T16:59:59.999Z',
      mission_title: {
        'en-US': 'Happy Weekly Missions',
        'th-TH': 'ภารกิจสุขสันต์ประจำสัปดาห์!',
        'zh-CN': '欢乐周任务！'
      },
      title: {
        'zh-CN': '每天只需登录',
        'th-TH': 'เพียงแค่ล็อกอิน',
        'en-US': 'Just login'
      },
      reward_amount: 10,
      label: 2,
      created_at: '2025-07-11T07:13:00.654Z'
    },
    {
      _id: '6870b10c6ee2a8920fcc7a79',
      vip_tier_id: null,
      mission_id: '1bde09a3-9796-438d-9e53-861b72b67977',
      mission_type: 4,
      activity_id: 'b2858523-dfb5-4d77-a86f-5ffff51f0749',
      expiration: '2025-07-18T16:59:59.999Z',
      mission_title: {
        'en-US': 'Happy Action Missions',
        'th-TH': 'ภารกิจแอ็คชั่นสุดสนุก',
        'zh-CN': '欢乐行动任务'
      },
      title: {
        'en-US': 'Just claim invite and earn reward',
        'th-TH': 'เพียงแค่รับค่าคอมมืสชั่นจากการเชีญเพื่อน',
        'zh-CN': '只需邀请好友即可赚取佣金'
      },
      reward_amount: 10,
      label: 2,
      created_at: '2025-07-11T06:37:00.556Z'
    }
  ]
}

export const PLAYER_EXCHANGE_HISTORY = {
  data: {
    total: 1,
    total_exchange_coins: 1,
    total_exchange_value: 1,
    totalPages: 1,
    data: [
      {
        id: 'c738b7f7-5bef-45f1-a780-b18277410a3d',
        status: 2,
        reward_type: 1,
        created_at: '2025-07-11T06:37:19.711Z',
        claim_date: '2025-07-11T06:37:19.711Z',
        exchange_coins: '1',
        exchange_value: '1',
        quantity: 1,
        reward_name: {
          'en-US': '1',
          'th-TH': '1'
        },
        tier_id: 'e75de843-4e80-4bc5-abad-0e732ee8e685',
        file: 'f243c25b-3479-43b8-b0e1-5688d15bacaf.png'
      }
    ]
  }
}
